export enum InterviewAnalysisSection {
  Summary = 'summary',
  QNAs = 'qnas',
  Transcript = 'transcript',
  Playback = 'playback',
}
